import React from 'react';
import FormNewAccount from './FormNewAccount';

const Index = (): JSX.Element => {
    return (
        <div className="d-flex flex-column flex-lg-row flex-column-fluid h-100">
            <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
                <FormNewAccount />
            </div>
            <div
                className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
                style={{
                    backgroundImage: "url('https://login.celeste.fr/azure-template/star.svg')",
                    backgroundColor: '#1E203C',
                }}
            >
                <div className="d-flex flex-column flex-center py-15 px-5 px-md-15 w-100">
                    <div>
                        <div className="block-logo">
                            <img
                                src="https://login.celeste.fr/azure-template/LOGO_CELESTE_Sans_Baseline_Blanc.png"
                                alt="Espace client Celeste"
                                style={{
                                    padding: '1rem 2rem',
                                }}
                            />
                        </div>
                    </div>
                    <h1 className="text-white fs-4qx fw-bold mb-7">ESPACE CLIENT</h1>
                </div>
            </div>
        </div>
    );
};

export default Index;
